import { useEffect, useState } from 'react';

/** Atrasa a propagação do valor. Usado na busca para não disparar uma
 *  consulta por tecla — o operador digita SKU de 5 dígitos no coletor. */
export function useDebounce<T>(valor: T, ms = 250): T {
  const [atrasado, definir] = useState(valor);
  useEffect(() => {
    const id = window.setTimeout(() => definir(valor), ms);
    return () => window.clearTimeout(id);
  }, [valor, ms]);
  return atrasado;
}
